import React from "react";
import { Tooltip as DsTooltip } from "@lmn/design-system";

const preventEventBubbling = (event: React.MouseEvent) =>
  event.preventDefault();

type HoverToolTipProps = {
  trigger: React.ReactElement;
  content: React.ReactElement | string;
  className?: string;
  placement?: "top" | "bottom" | "left" | "right";
  title?: string;
};

const HoverToolTip = ({
  trigger,
  content,
  className,
  placement = "top",
  title,
  ...props
}: HoverToolTipProps) => (
  <DsTooltip content={content} placement={placement} title={title}>
    <span
      {...props}
      className={className}
      onClick={preventEventBubbling}
      style={{
        width: "fit-content",
        display: "inline-flex",
        verticalAlign: "top",
      }}
    >
      {trigger}
    </span>
  </DsTooltip>
);

export default HoverToolTip;
